import { NgModule } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { MatSortModule } from '@angular/material/sort';
import { EquivalentRoutingModule } from './equivalent-routing.module';
import { EquivalentOverviewComponent } from './equivalent-overview/equivalent-overview.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { RemoveEquivalentDialogComponent } from './remove-equivalent-dialog/remove-equivalent-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { CreateEquivalentFormComponent } from './create-equivalent-form/create-equivalent-form.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDividerModule } from '@angular/material/divider';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ImportEquivalentFormComponent } from './import-equivalent-form/import-equivalent-form.component';
import { MatToolbarModule } from '@angular/material/toolbar';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatTableModule,
    MatPaginatorModule,
    MatCardModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatSortModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatFormFieldModule,
    MatDividerModule,
    MatSelectModule,
    MatCheckboxModule,
    MatToolbarModule,
    ReactiveFormsModule,
    EquivalentRoutingModule,
  ],
  declarations: [
    EquivalentOverviewComponent,
    RemoveEquivalentDialogComponent,
    CreateEquivalentFormComponent,
    ImportEquivalentFormComponent,
  ],
})
export class EquivalentModule { }
